import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const CarteraTabs = ({ options, tabActive, onChange, children }) => {
	const [internalActive, setInternalActive] = useState(tabActive !== undefined ? tabActive : 0);

	const activeTab = tabActive !== undefined ? tabActive : internalActive;

	const handleTabChange = (index) => {
		if (tabActive === undefined) {
			setInternalActive(index);
		}
		if (onChange) {
			onChange(index);
		}
	};

	return (
		<div className="cartera-tabs-wrapper">
			<div className="cartera-tabs-header">
				{options.map((option, index) => (
					<button
						key={option.label}
						className={`cartera-tab ${activeTab === index ? 'active' : ''}`}
						onClick={() => handleTabChange(index)}
						type="button"
					>
						{option.label}
					</button>
				))}
			</div>
			<div className="cartera-tabs-content">
				<div className="cartera-tab-pane active">
					{React.Children.toArray(children)[activeTab]}
				</div>
			</div>
		</div>
	);
};

CarteraTabs.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
		})
	).isRequired,
	tabActive: PropTypes.number,
	onChange: PropTypes.func,
	children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export default CarteraTabs;
